export default __webpack_public_path__ + "static/media/ccstype1.45060a0e.png";